<div class="container"><br>
  <div class="form-group">
    <label>{{question.question_copy}}</label>
    <input mask="percent" suffix="%" type="tel"
           (ngModelChange)="onChange(0)" maxlength="3"
           [class]="'form-control answers ' + question.cent_aq_question_id"
           [(ngModel)]="currentVap.answer"
           [id]="question.cent_aq_question_id"
           [placeholder]="'Max ' + currentVap.value_max + '%'">
  </div>
</div>
